import api from './api'
import { getDecryptOSSData } from "@/utils"
import { removeToken, setToken, setUser } from '@/utils/auth'
const SERVER = {
  authUrl: '/auth', // 登录
  codeLoginUrl: '/auth/code_login', // 登录
  loginUrl: '/auth/login', // 认证
  queryUserInfoUrl: '/auth/current', // 获取用户信息
  campsiteListUrl: '/operations/campsite/list', // 首页三营信息
  materialListUrl: '/operations/material/list', // 资料分类信息
  subjectUrl: '/operations/school/subject/info', // 机构学科信息
  confirmUrl: '/operations/feedback/confirm', // 确认学科信息
  gradeUrl: '/operations/material/grade/list', // 机构年级列表
  detailUrl: '/operations/material/detail/list', // 机构资料列表
  feedbackUploadUrl: '/operations/feedback/upload', // 反馈资料上传
  feedbackListUrl: '/operations/feedback/list', // 机构反馈列表
  feedbackDeleteUrl: '/operations/feedback/delete', // 资料删除
  feedbackSubmitUrl: '/operations/feedback/submit', // 提交反馈资料
  queryOSSUrl: '/aliyun/oss/sts_token', // 上传阿里云
  queryEncryptOSSUrl: '/aliyun/oss/sts_token_encrypt', // 加密接口
  receiveUrl: '/operations/campsite/branch/receive' // 向后台传入三营报名的数据
}

function auth (params) {
  params.type = 2
  return api.post(SERVER.authUrl, params).then(res => {
    if (res.status_code === 200) {
      removeToken()
      return login({
        id: res.data.users[0].id, // TODO 如果登录在这里用需要判断学校个数来提示选择
        token: res.data.token,
        type: 2
      })
    }
  })
}

function codeLogin (params) {
  params.type = 2
  return api.post(SERVER.codeLoginUrl, params).then(res => {
    if (res.status_code === 200) {
      removeToken()
      return login({
        id: res.data.users[3].id, // TODO 如果登录在这里用需要判断学校个数来提示选择
        token: res.data.token,
        type: 2
      })
    }
  })
}

function login (params) {
  params.type = 2
  return api.post(SERVER.loginUrl, params).then(res => {
    if (res.status_code === 200) {
      setToken(res.data.token)
      /* eslint-disable */
      let { id, name, role_name, school, avatar_url, cooperation_type } = res.data.user
      setUser({
        id,
        name,
        role_name,
        school_name: school.name,
        school_id: school.id,
        avatar_url,
        is_teach: school.is_teach,
        is_live: school.is_live,
        cooperation_type
      })
    }
    return res
  })
}

function campsiteList (params) {
  return api.get(SERVER.campsiteListUrl, { params }).then(res => {
    return res
  })
}

function materialList (params) {
  return api.get(SERVER.materialListUrl, { params }).then(res => {
    return res
  })
}

function subject (params) {
  return api.post(SERVER.subjectUrl, params).then(res => {
    return res
  })
}

function confirm (params) {
  return api.post(SERVER.confirmUrl, params).then(res => {
    return res
  })
}

function grade (params) {
  return api.get(SERVER.gradeUrl, { params }).then(res => {
    return res
  })
}

function detail (params) {
  return api.get(SERVER.detailUrl, { params }).then(res => {
    return res
  })
}

function feedbackUpload (params) {
  console.log(params)
  return api.post(SERVER.feedbackUploadUrl, params).then(res => {
    console.log(res)
    return res
  })
}

function feedbackList (params) {
  return api.get(SERVER.feedbackListUrl, { params }).then(res => {
    return res
  })
}

function feedbackDelete (params) {
  return api.post(SERVER.feedbackDeleteUrl, params).then(res => {
    return res
  })
}

function feedbackSubmit (params) {
  return api.post(SERVER.feedbackSubmitUrl, params).then(res => {
    return res
  })
}

function queryOSS (params) {
  return api.post(SERVER.queryEncryptOSSUrl, params).then(res => {
    return {...res,data: getDecryptOSSData(res.data)}
  })
}

function receive (params) {
  return api.post(SERVER.receiveUrl, params).then(res => {
    return res
  })
}

/**
   * 获取当前用户信息
   */
function queryUserInfo (params) {
  return api.get(this.queryUserInfoUrl, { params }).then(res => {
    return res
  })
}

export default {
  auth,
  codeLogin,
  login,
  queryUserInfo,
  campsiteList,
  materialList,
  subject,
  confirm,
  grade,
  detail,
  feedbackUpload,
  feedbackList,
  feedbackDelete,
  feedbackSubmit,
  queryOSS,
  receive
}
